<script>
import Translatable from '@src/mixins/translatable.js'
import { required, email } from 'vuelidate/lib/validators'

export default {
  mixins: [
    Translatable
  ],
  validations: {
    email: {
      email,
      required
    },
  },
  data() {
    return {
      email: ''
    }
  },
  methods: {
    submitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.$store.dispatch('reviews/subscribeEmail', this.email)
        this.$emit('subscribe')
      }
    }
  }
}
</script>

<template>
  <form class="subscribe-form">
    <label>
      <input v-model="$v.email.$model" name="email" type="email" :placeholder="getTranslatedContent('ENTER_EMAIL_PLACEHOLDER')">
    </label>
    <button @click.prevent="submitForm" type="submit" class="subscribe-btn">{{ getTranslatedContent('EMAIL_SUBSCRIBE') }}</button>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';

.subscribe-form {
  min-width: 333px;
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

input {
  width: 227px;
  height: 48px;
  background: #FFFFFF;
  border-radius: 5px;
  border: none;
  text-indent: 23.75px;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  padding: 0 106px 0 0;
}

input::placeholder {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: rgba(37, 44, 62, 0.6);
}

button {
  background: $orange;
  border: 2px solid $orange;
  border-radius: 0 5px 5px 0;
  min-width: 106px;
  width: auto;
  height: 48px;
  margin-left: -106px;
  padding: 0 15px;
  white-space: nowrap;

  text-transform: uppercase;
  font-family: Open Sans Semibold, sans-serif; // temp-text
  font-weight: 600;
  // font-family: Open Sans, sans-serif;
  // font-weight: normal;
  font-size: 15px;
  line-height: 130%;
  color: white;
}

button:hover {
  background: $hover-orange;
  border: 2px solid $hover-orange;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $screen-width-xs) {
  input {
    width: 198px;
  }

  .subscribe-form {
    width: 304px;
  }
}
</style>
